/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  PayeeVerificationRequest,
  PayeeVerificationResponseDto,
  VerifyAccountsPayablePayeeBatchRequest,
  VerifyAccountsPayablePayeeBatchResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class PayeeController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags payee-controller
   * @name VerifyPayee
   * @request POST:/api/v1/payee/verify
   */
  verifyPayee = (data: PayeeVerificationRequest, params: RequestParams = {}) =>
    this.http.request<PayeeVerificationResponseDto, any>({
      path: `/v1/payee/verify`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static verifyPayeePath = '/v1/payee/verify'
  static verifyPayeeMethod = 'POST'
  /**
   * No description
   *
   * @tags payee-controller
   * @name VerifyPayeeBatch
   * @request POST:/api/v1/payee/verify/accounts-payable/batch
   */
  verifyPayeeBatch = (data: VerifyAccountsPayablePayeeBatchRequest, params: RequestParams = {}) =>
    this.http.request<VerifyAccountsPayablePayeeBatchResponse, any>({
      path: `/v1/payee/verify/accounts-payable/batch`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static verifyPayeeBatchPath = '/v1/payee/verify/accounts-payable/batch'
  static verifyPayeeBatchMethod = 'POST'
}
